import { ArrayValue, RecordValue, Schema, StringValue } from '@coveo/bueno';
import { categoryFacetSortCriteria, } from '../../../../features/facets/category-facet-set/interfaces/request.js';
import { facetId, field, basePath, delimitingCharacter, filterByBasePath, filterFacetCount, injectionDepth, numberOfValues, facetSearch, } from '../_common/facet-option-definitions.js';
export const categoryFacetOptionsSchema = new Schema({
    field,
    tabs: new RecordValue({
        options: {
            required: false,
        },
        values: {
            included: new ArrayValue({ each: new StringValue() }),
            excluded: new ArrayValue({ each: new StringValue() }),
        },
    }),
    basePath,
    delimitingCharacter,
    facetId,
    facetSearch,
    filterByBasePath,
    filterFacetCount,
    injectionDepth,
    numberOfValues,
    sortCriteria: new StringValue({
        constrainTo: categoryFacetSortCriteria,
    }),
});
